import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../app/store";
import { Language } from "../types/Languages";
import { TranslationsRecord } from "../types/TranslationsRecord";

interface ILocalizationSlice {
  translations: TranslationsRecord;
  language: Language;
  languages: Language[];
}

const initialState: ILocalizationSlice = {
  translations: {},
  language: {
    language: "English",
    abbreviation: "EN",
    cultureName: "en-US",
  },
  languages: [
  {
    language: "English",
    abbreviation: "EN",
    cultureName: "en-US",
  },
  {
    language: "Czech",
    abbreviation: "CZ",
    cultureName: "cs-CZ",
  },
  {
    language: "German",
    abbreviation: "DE",
    cultureName: "de-DE",
  },
  {
    language: "Italian",
    abbreviation: "IT",
    cultureName: "it-IT",
  },
  {
    language: "Spanish",
    abbreviation: "ES",
    cultureName: "es-ES",
  },
  {
    language: "French",
    abbreviation: "FR",
    cultureName: "fr-FR",
  },
  {
    language: "Dutch",
    abbreviation: "NL",
    cultureName: "nl-NL",
  },
  {
    language: "Polish",
    abbreviation: "PL",
    cultureName: "pl-PL",
  },
  {
    language: "Portuguese",
    abbreviation: "PT",
    cultureName: "pt-BR",
  }
  ]
};

export const localizationSlice = createSlice({
  name: "localization",
  initialState,
  reducers: {
    setTranslations: (state, action: PayloadAction<TranslationsRecord>) => {
      if (!action.payload || Object.keys(action.payload).length === 0) {
        // fallback to English
        state.language = {
          language: "English",
          abbreviation: "EN",
          cultureName: "en-US",
        };
        return; // no translations to set
      }

      state.translations = action.payload;
    },
    setLanguage: (state, action: PayloadAction<Language>) => {
      state.language = action.payload;
    },
    setLanguages: (state, action: PayloadAction<Language[]>) => {
      state.languages = action.payload;
    },
  },
});

export default localizationSlice.reducer;

export const { setTranslations, setLanguage, setLanguages } = localizationSlice.actions;

export const selectTranslations = (state: RootState) => state.localization.translations;
export const selectLanguage = (state: RootState) => state.localization.language;
export const selectLanguages = (state: RootState) => state.localization.languages;
